// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/integrations.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanSuppressIntegrationMessage } from "./hook";

export type CanSuppressIntegrationMessageProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanSuppressIntegrationMessage({
  children,
  fallback,
  scope,
}: CanSuppressIntegrationMessageProps) {
  const canDoAction = useCanSuppressIntegrationMessage(scope);
  return <>{canDoAction ? children : fallback}</>;
}
